module.exports = __webpack_public_path__ + "img/xuc.721b3ad5.svg";